import { useQuery } from '@tanstack/react-query';

import { getProgramYears } from '@/api/program';
import { useFeature } from '@/hooks/useFeature';
import { programYearKeys } from '@/lib/queryKeys';

/**
 * 사업 연도 선택지 — 연도는 연 1회 늘어나므로 길게 캐시한다(새로 고침 버튼은 전체 무효화로 다시 받는다).
 * 연도 API 는 사업 상세 기능(PROGRAM_DETAIL)이라 그 기능이 없는 회원(기업, specs/065)은 묻지 않는다.
 */
export function useProgramYears() {
  const enabled = useFeature('PROGRAM_DETAIL');
  return useQuery({
    enabled,
    queryKey: programYearKeys.list,
    queryFn: getProgramYears,
    staleTime: 10 * 60_000,
  });
}
